import { createContext, useContext } from 'react';
import type { TFlowEdge } from '@hookpipe/contracts/flows/schemas/flow-graph.schema';

import type { TAnchor } from './anchor';
import type { IConnectDrag } from './connect';

export interface ICanvasContext {
  drag: IConnectDrag | null;
  /** Keyboard connect: the number each valid target answers to. */
  keyTargets?: ReadonlyMap<string, number>;
  hoveredEdge: string | null;
  hoverEdge: (id: string | null) => void;
  nameOf: (key: string) => string;
  onAddAfter?: (port: { from: string; output: string }, anchor: TAnchor) => void;
  onInsertOnEdge?: (edge: TFlowEdge, anchor: TAnchor) => void;
  onToggleHandled?: (edge: TFlowEdge) => void;
  onToggle?: (key: string) => void;
}

// xyflow renders nodes and edges itself, so what they need from the canvas comes through here.
export const CanvasContext = createContext<ICanvasContext>({
  drag: null,
  hoveredEdge: null,
  hoverEdge: () => undefined,
  nameOf: (key) => key,
});

export const useCanvas = (): ICanvasContext => useContext(CanvasContext);
